import TableLoader from '@/components/Common/Table/TableLoader/TableLoader';
import COLORS from '@/constants/colors';
import { PROPS } from '@/layouts/TableLayout/TableLayout.utils';
import Box from '@mui/material/Box';
// import Nav from '@/components/Common/Nav/Nav';

export default function TableLayout({
  // links = [],
  header,
  body,
  pagination,
  isLoading,
}: PROPS) {
  return (
    <Box
      sx={{
        backgroundColor: 'white',
        my: '16px',
        border: `1px solid ${COLORS.gray_6}`,
        borderRadius: '8px',
        boxShadow: `0px 4px 20px 0px ${COLORS.tableShadow}`,
        mx: { xs: '16px', md: '0px' },
      }}
    >
      {/* {links.length ? (
        <Box sx={styles.nav}>
          <Nav links={links} horizontal />
        </Box>
      ) : null} */}
      {header && (
        <Box
          sx={{
            p: '24px 22px',
            borderBottom: `1px solid ${COLORS.gray_6}`,
          }}
        >
          {header}
        </Box>
      )}
      {isLoading ? <TableLoader /> : body}
      {pagination}
    </Box>
  );
}
